import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Spinner from '../layout/Spinner';
import {S3_UPLOAD_CERTIFICATES_LIST, YES_NO_ARRAY, NATIVITY, ELIGIBILITY_TYPE, DIFF_ABLED_TYPES, NATIONALITY, QUALIFYING_DEGREE, PATTERN_OF_STUDY, APPEARANCE_FINAL_YEAR_EXAM} from '../../Constant';
import {Card, ListGroup, CardSubtitle, CardTitle, CardText, ListGroupItem, CardBody, Table, Row} from 'reactstrap';

import { clearApplication2} from '../../actions/master';
import {listAll, openCert, gettfc} from '../../actions/dload';

import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import {saveAs} from 'save-as';


//const {GENDER, RELIGION, NATIONALITY, NATIVITY, YES_NO_ARRAY} = require("../../Constant");

const Dload2 = ({
  getProfileCor,
  getIncomplete,
  listAll, openCert, gettfc,
  auth: { user },
  profile: {logloading, allapplns, fnames, profile, profile2, applnid, loading, getdb },
  history, 
  clearApplication2,
  changeAppStatus
}) => {

  useEffect(() => {
    window.scrollTo(0,0);
  }, []); 

  /*useEffect(() => {
   gettfc(applnid);       
    //console.log(logprofile);
    //console.log("invoking s3 list");
    
   listAll(applnid);
    //console.log("completed retrieving the list");
  }, [applnid, listAll, gettfc]); */

    
  var zip = new JSZip();

    const [sloading, setsLoading] = useState(false);

    async function downzip() {

      setsLoading(true);
      try {

      const remoteZips = allapplns.map(async function(cert) {
        console.log(cert.durl);
        var filename = "filename";
        // loading a file and add it in a zip file
        const response = await fetch(cert.durl);
        const data = await response.blob();
        zip.file(`${cert.id}.${cert.PROPS.ext}`, data);
        return data;
      });
      Promise.all(remoteZips).then(() => {
        zip.generateAsync({ type: "blob" }).then((content) => {
          saveAs(content, `${profile._aid}.zip`);
        });
        setsLoading(false);
      })
      .catch(() => {
        setsLoading(false);
      })

      setsLoading(false);
    } catch(error)
    {
      setsLoading(false);
    }
    };


  var certnames = [];
  certnames.push({key: 1, value: "x"});
  certnames.push({key: 2, value: "xi"});
  certnames.push({key: 2, value: "xii"});
  certnames.push({key: 3, value: "tc"});
  certnames.push({key: 4, value: "passport_photo"});
  certnames.push({key: 5, value: "sign"});

  //certnames.push({key: 6, value: "Sports Certificates"});
  /*certnames.push({key: 5, value: "Community Certificate"});
  certnames.push({key: 6, value: "Differently abled Certificate"});
  certnames.push({key: 7, value: "Ex-Servicemen Certificate"});
  certnames.push({key: 8, value: "Nativity Certificate (Only for Others)"});
  certnames.push({key: 9, value: "Additional Proof for Nativity"});
  certnames.push({key: 10, value: "Srilankan Refugee Certificate"});
  certnames.push({key: 11, value: "First Graduate Certificate"});
  certnames.push({key: 12, value: "Income Certificate"});*/

  /*const [formData, setFormData] = useState({
    gappid: '',
    _aid: '', _n: '',
    vflag : "notyet",
    cremarks: '',
    status: '',
    tfcname: '',
    username: '',
    ltype: ''
  });*/

  const onBack = async e => {    
    history.push('/dashboard');    
  };

  function loadcerts() {
    //("invoking init " + logloading);
    if(loading === true)
    {      
      if(profile && profile._p && profile._p.co !== "OC")
        certnames.push({key: 6, value: "community"});
      
      if(profile && profile._sr && profile._sr.dap === "Y" && profile._sr.adt  === "1")
        certnames.push({key: 7, value: "diff_abled_blind"});

      if(profile && profile._sr && profile._sr.dap === "Y" && profile._sr.adt === "2")
        certnames.push({key: 7, value: "diff_abled_deaf"});
      
      if(profile && profile._sr && profile._sr.dap === "Y" && profile._sr.adt === "3")
        certnames.push({key: 7, value: "diff_abled_loco"});
      
      if(profile && profile._sr && profile._sr.dap === "Y" && profile._sr.adt === "4")
        certnames.push({key: 7, value: "diff_abled_autism"});
      
      if(profile && profile._sr && profile._sr.dap === "Y" && profile._sr.adt === "5")
        certnames.push({key: 7, value: "diff_abled_multiple"});
      
      if(profile && profile._sr && profile._sr.ex === "Y")
          certnames.push({key: 8, value: "exservice"});

      if(profile && profile._p && profile._p.nt === "TN" && profile._sc.sit === "N")
          {
            certnames.push({key: 9, value: "nativity"});
          }
      if(profile && profile._p && profile._sc.sit === "Y" && profile._p.nt === "OTH")
          {
            certnames.push({key: 9, value: "eligibility"});
          }

      if(profile && profile._p && profile._p.ny === "SLR")
          certnames.push({key: 10, value: "srilankanRefuge"});


    }
  }

  //const { gappid, cremarks } = formData;

  /*const onChange = e => {
    setFormData({ ...formData, [e.target.name] : e.target.value });  
    //name: e.target.value to change name alone
    //console.log(e.target.value);
  }

 /* const onDownload = e => {
    e.preventDefault();
    clearProf(e);
    history.push('/download');
  }*/

  /*const onSubmit = async e => {
    e.preventDefault();     
    
    await clearApplication2(history);

    //console.log("Appln number : "+ formData.gappid);   
    await gettfc(formData.gappid);       
    //console.log(logprofile);
    //console.log("invoking s3 list");
    
    await listAll(formData.gappid);
    //console.log("completed retrieving the list");
   
  };

  
  const clearProf = async e => {    
    clearApplication2(history);
    formData.gappid = '';
  };*/


  return (    
    
    <Fragment>
    
      <h5 style={{textAlign: 'center', color: "blue", fontSize: "11pt", fontWeight: "bolder"}}> TFC Centre: {user && user.tfcname} </h5>

      {logloading ? loadcerts() : null }
      
        
      {allapplns && allapplns.length > 0 && user && (user.ltype === 'V' || user.ltype === 'U')  &&
      

      <div className="m-2">     

        <div className="container badge" style={{fontWeight: 'bold', background: 'lightgrey'}}>
        <h5 style={{fontWeight: "bold", color: "red"}}>                  
              Candidate Details
        </h5>
        </div>         
        
        <Row className="grid-3 badge" style={{fontWeight: "bold", color: "black", textAlign: "center", fontSize: "13pt", border: "1px solid grey", lineHeight: "50px", fontFamily: "verdana"}}>  
            <div>Application Number: {profile._aid} </div>
            <div>Name: {profile._n}</div>
            <div>Course: {profile._co}</div>
        </Row>
         
             
              <div className="grid-4" style={{textAlign: "center" ,color: "darkred", fontSize: "11pt", fontWeight: "bolder", backgroundColor: "white", border: "1px solid grey"}}>
              <div > Community: <span style={{fontWeight: 'bold', color: "black"}}> {profile && profile._p && profile._p.co} </span> </div>
                
                <div > Differently abled: <span style={{fontWeight: 'bold' , color: "black"}}> { profile._p && profile._p._df && YES_NO_ARRAY.filter(e => e.key.toString() === profile._p._df.toString()).map(e => e.label)} </span> </div>                    

                <div > Citizenship: <span style={{fontWeight: 'bold' , color: "black"}}> {profile && profile._p && profile._p.ny && NATIONALITY.filter(e => e.key.toString() === profile._p.ny.toString()).map(e => e.label)} </span> </div>                    
                
                <div > Nativity: <span style={{fontWeight: 'bold', color: "black"}}> {profile && profile._p && profile._p.nt && NATIVITY.filter(e => e.key.toString() === profile._p.nt.toString()).map(e => e.label)} </span> </div>                
                

                <div > Srilankan Tamil Refugee: <span style={{fontWeight: 'bold', color: "black"}}> 
                { profile._p && profile._p._sri && YES_NO_ARRAY.filter(e => e.key.toString() === profile._p._sri.toString()).map(e => e.label)}
                </span></div>


                <div > Degree: <span style={{fontWeight: 'bold', color: "black"}}> 
                {profile._p && profile._p._qd && QUALIFYING_DEGREE.filter(e => e.key.toString() === profile._p._qd.toString()).map(e => e.label)} </span> </div>

                <div> Pattern of Study: <span style={{fontWeight: 'bold', color: "black"}}> {profile._p && profile._p._ps && PATTERN_OF_STUDY.filter(e => e.key.toString() === profile._p._ps.toString()).map(e => e.label)} </span> </div>


              <div> Appearance in Final Year Exam: <span style={{fontWeight: 'bold', color: "black"}}> {profile._p && profile._p._afe && APPEARANCE_FINAL_YEAR_EXAM.filter(e => e.key.toString() === profile._p._afe.toString()).map(e => e.label)} </span> </div>


                <div> TANCET Registration Number: <span style={{fontWeight: 'bold', color: "black"}}> {profile._tn &&  profile._tn} </span> </div>

              <div> TANCET Marks: <span style={{fontWeight: 'bold', color: "black"}}> {profile._p &&  profile._p._tnm} </span> </div>



              </div>
            
            <div>
            
          </div>


<>
        <div className="container badge" style={{fontWeight: 'bold', background: 'lightgrey'}}>
        <h5 style={{fontWeight: "bold", color: "navy"}}>                  
            Uploaded Certificates
        </h5>
        </div>         


            <div className="table-responsive" style={{paddingTop: "20px", fontWeight: "bold"}}>        
            
            <table className="table" style={{ color: "black", fontSize: "9pt"}} >
            <thead>
              
              <tr style={{color: "black", fontWeight: "bolder"}}>   
                <th style={{backgroundColor: "#E8F8F5"}} scope="col"> Sl.No </th>             
                
                <th style={{backgroundColor: "#E8F8F5"}} scope="col"> Certificate Name </th>                
                                             

                <th style={{backgroundColor: "#E8F8F5"}} scope = "col" > Download File </th> 

                <th style={{backgroundColor: "#E8F8F5"}} scope = "col" > Saved File </th> 
            
              </tr>
            </thead>
            <tbody>

          
          {allapplns && allapplns.map((cert, i) => (
            <tr key={i} >            
            <td style={{textAlign: "left", fontSize: "10pt"}}> {i+1} </td>    
            
            <td style={{color: "red", fontWeight: "bold", textAlign: "left", fontSize: "10pt"}}>             
            {cert.id.toString()}
            </td>

            <td style={{color: "red", fontSize: "11pt"}}> 
            
                <a  target="_blank" rel="noopener noreferrer"  style={{textDecoration: "underline", color: "crimson"}} href={cert.durl}> Download </a> 
            </td>

            <td style={{color: "navy", fontSize: "10pt"}}> 
              {cert.fileName} <br /> 
              <span style={{color: "green"}}>
              Size: {cert.PROPS && Math.round(cert.PROPS.size/1024)} KB  
              </span>
            </td>

          </tr>   ) ) }

          </tbody>
          </table>
            
          </div> 
          </>  

          </div> 
        }
        <Row className="my-3 but-center">
          <input type='submit' className='row btn btn-white' style={{color: "navy", fontWeight: "bolder"}} onClick={downzip} value="Download all Certficates as Zip file"/>
        </Row>        

        <Row className="my-3 but-center">
          <input type='submit' className='row btn btn-success' onClick={ e => onBack(e) } value="Back"/>
          </Row>         

    </Fragment>
    
  );
}

Dload2.propTypes = {
  clearApplication2: PropTypes.func.isRequired,
  openCert: PropTypes.func.isRequired,
  gettfc: PropTypes.func.isRequired,
  listAll: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth,
  profile: state.profile
});

export default connect(
  mapStateToProps,
  { clearApplication2, listAll, openCert, gettfc}
)(Dload2);
